module.exports = __webpack_public_path__ + "static/media/homepageBg.cb829623.svg";